/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  CLOSED_REFUND_CUSTOMER_DESCRIPTION,
  CLOSED_REFUND_SELLER_DESCRIPTION,
  CLOSED_RELEASE_BUYER_DESCRIPTION,
  CLOSED_RELEASE_PROVIDER_DESCRIPTION,
  CLOSED_STATUS,
  RESOLVE_BUYER_REFUND_STATUS_BUYER_DESCRIPTION,
  RESOLVE_BUYER_REFUND_STATUS_SELLER_DESCRIPTION,
  RESOLVE_SELLER_REALSE_STATUS_BUYER_DESCRIPTION,
  RESOLVE_SELLER_REALSE_STATUS_SELLER_DESCRIPTION,
  RESOLVED_STATUS,
} from "../../../../components/contractListItem/constants";
import { ECONTRACT_STATUS } from "../../../../enums";
import {
  EEscalaionType,
  ESenderRole,
} from "../../../../setup/api/services/contract/models";
import { AuthConfig } from "../../../../setup/context/config/authConfig";
import { IContractStatusProps } from "../models";
import styles from "./styles.module.scss";

const Status = (props: IContractStatusProps) => {
  const { contract, actorType } = props;
  const status = contract.status;
  const userId = AuthConfig.getUserInfo()?.id;

  const [img, setImg] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [backGroundColor, setBackGroundColor] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  const { t } = useTranslation();
  useEffect(() => {
    setStatusItems();
  }, [status]);
  const setStates = ({ compImg, compTitle, backGround, compDesc }: any) => {
    setImg(compImg);
    setTitle(compTitle);
    setBackGroundColor(backGround);
    setDescription(compDesc);
  };

  const checkIfEscalationIsFromProvider = () => {
    let currentEscalations = false;
    contract.escalations?.filter((escalation) => {
      currentEscalations =
        escalation.escalationType ===
          EEscalaionType.PROVIDER_ESCALATE_DELIVERY ||
        escalation.escalationType === EEscalaionType.PROVIDER_ESCALATE_ITEM;
    });
    return currentEscalations ? true : false;
  };
  const rerturnEscalationDescription = () => {
    const currentActiveEscalation = contract.escalations?.filter(
      (escalation) => {
        return (
          escalation.userId == userId &&
          escalation.resolved === false &&
          escalation.escalationType !==
            EEscalaionType.CUSTOMER_CHECK_ESCALATION &&
          escalation.escalationType !== EEscalaionType.PROVIDER_CHECK_ESCALATION
        );
      }
    );
    if (currentActiveEscalation && currentActiveEscalation.length != 0) {
      return t("lbl_contract_list_item_arbitration_status_description");
    } else {
      if (checkIfEscalationIsFromProvider()) {
        return t("lbl_contract_list_arbitration_status_description_buyer");
      } else
        return t("lbl_contract_list_arbitration_status_description_seller");
    }
  };
  const setStatusItems = () => {
    switch (status) {
      case ECONTRACT_STATUS.CREATED:
        setStates({
          compImg: "/assets/images/svg/active.svg",
          compTitle: t("lbl_contract_details_transaction_active"),
          backGround: "rgba(68, 193, 110, 0.07)",
          compDesc:
            actorType === ESenderRole.PROVIDER
              ? t("lbl_contract_list_active_status_description_seller")
              : t(
                  "lbl_contract_details_transaction_status_active_buyer_sub_title"
                ),
        });
        break;

      case ECONTRACT_STATUS.COMPLETED:
        setStates({
          compImg: "/assets/images/svg/done.svg",
          compTitle: t("lbl_contract_details_completed_state_title"),
          backGround: styles.ContractStatus,
          compDesc:
            actorType === ESenderRole.PROVIDER
              ? t(
                  "lbl_contract_details_contract_completed_state_seller_sub_title"
                )
              : t(
                  "lbl_contract_details_contract_completed_state_buyer_sub_title"
                ),
        });
        break;

      case ECONTRACT_STATUS.WAITING_FOR_DELIVERY:
        setStates({
          compImg: "/assets/images/svg/shipping.svg",
          compTitle: t("lbl_waiting_shipping_contract_status_title"),
          backGround: "rgba(83, 55, 195, 0.05)",
          compDesc:
            actorType === ESenderRole.PROVIDER
              ? t(
                  "lbl_contract_list_waiting_for_shipping_status_description_seller"
                )
              : t(
                  "lbl_contract_details_waiting_for_delivery_state_buyer_sub_title"
                ),
        });
        break;
      case ECONTRACT_STATUS.ITEM_ACCEPTED:
        setStates({
          compImg: "/assets/images/svg/done.svg",
          compTitle: t("lbl_contract_accepted_contract_status_title"),
          backGround: "rgba(99, 202, 250, 0.07)",
          compDesc:
            actorType === ESenderRole.PROVIDER
              ? t(
                  "lbl_contract_details_contract_accepted_state_seller_sub_title"
                )
              : t(
                  "lbl_contract_details_contract_accepted_state_buyer_sub_title"
                ),
        });
        break;
      case ECONTRACT_STATUS.ITEM_INSPECTION:
        setStates({
          compImg: "/assets/images/svg/inspection.svg",
          compTitle: t("lbl_contract_list_items_wating_for_inspection"),
          backGround: "rgba(99, 202, 250, 0.07)",
          compDesc:
            actorType === ESenderRole.PROVIDER
              ? t("lbl_contract_details_item_inspection_state_seller_sub_title")
              : t("lbl_contract_details_item_inspection_state_buyer_sub_title"),
        });
        break;
      case ECONTRACT_STATUS.INSPECTION_ESCALATION:
      case ECONTRACT_STATUS.DELIVERY_ESCALATION:
        setStates({
          compImg: "/assets/images/svg/arbitration.svg",
          compTitle: t(
            "lbl_delivery_inspection_escalation_contract_status_title"
          ),
          backGround: "rgba(209, 139, 73, 0.07)",
          compDesc: rerturnEscalationDescription(),
        });
        break;
      case ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER:
        setStates({
          compImg: "/assets/images/svg/judge.svg",
          compTitle: RESOLVED_STATUS,
          backGround: "rgba(0, 224, 191, 0.07)",
          compDesc:
            actorType === ESenderRole.PROVIDER
              ? RESOLVE_BUYER_REFUND_STATUS_SELLER_DESCRIPTION
              : RESOLVE_BUYER_REFUND_STATUS_BUYER_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER:
        setStates({
          compImg: "/assets/images/svg/judge.svg",
          compTitle: RESOLVED_STATUS,
          backGround: "rgba(0, 224, 191, 0.07)",
          compDesc:
            actorType === ESenderRole.PROVIDER
              ? RESOLVE_SELLER_REALSE_STATUS_SELLER_DESCRIPTION
              : RESOLVE_SELLER_REALSE_STATUS_BUYER_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.CLOSED_REFUND_CUSTOMER:
        setStates({
          compImg: "/assets/images/svg/judge.svg",
          compTitle: t("CLOSED_STATUS"),
          backGround: "rgba(0, 224, 191, 0.07)",
          compDesc:
            actorType === ESenderRole.PROVIDER
              ? CLOSED_REFUND_SELLER_DESCRIPTION
              : CLOSED_REFUND_CUSTOMER_DESCRIPTION,
        });
        break;
      case ECONTRACT_STATUS.CLOSED_RELEASE_PROVIDER:
        setStates({
          compImg: "/assets/images/svg/judge.svg",
          compTitle: CLOSED_STATUS,
          backGround: "rgba(0, 224, 191, 0.07)",
          compDesc:
            actorType === ESenderRole.PROVIDER
              ? CLOSED_RELEASE_PROVIDER_DESCRIPTION
              : CLOSED_RELEASE_BUYER_DESCRIPTION,
        });
        break;
      default:
        break;
    }
  };
  return (
    <div className={styles.status}>
      <h4 className={styles.status_header}>
        {t("lbl_contract_details_transaction_status")}
      </h4>
      <div
        className={styles.status_card}
        style={{ background: backGroundColor }}>
        <div className={styles.status_row}>
          <img alt="" src={img} />
          <div className={styles.status_text_wrapper}>
            <p className={"subtitle2"}>{title}</p>
            <p className={"hint2"}>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Status;
